// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}
#app {
  height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base.less"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,UAAA;EACA,yHAAA;AAAF;AAKA;EACE,aAAA;AAHF","sourcesContent":["// 基础样式文件\nbody {\n  margin: 0;\n  padding: 0;\n  font-family:\n    'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',\n    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;\n}\n\n#app {\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
